import React, { useState, useCallback, useEffect } from 'react';
//import React, {  } from 'react';
import './profile.scss';
//import Form from 'devextreme-react/form';
import Form, { Item, GroupItem, Label } from 'devextreme-react/form';
import 'devextreme-react/text-area';
import service from '../../data/data.js';
import LabelNotesTemplate from '../../labels/LabelNotesTemplate.js';
import LabelTemplate from '../../labels/LabelTemplate.js';
import GlobalParams from '../../helpers/GlobalParams.js';
import { DataGrid } from 'devextreme-react';
import { Column } from 'devextreme-react/cjs/data-grid.js';
import axios from 'axios';




const validationRules = {
  email: [{ type: 'required', message: 'Email is required.' }],
  mobile: [{ message: 'Mobile is required.' }],
  address: [{ type: 'required', message: 'Address is required.' }],
  pin_no: [{ type: 'required', message: 'Pin Number is required.' }],
};
const nameEditorOptions = { readOnly: true };
const emailEditorOptions = { readOnly: true };
const physicalAddressEditorOptions = { readOnly: true };
const pin_noEditorOptions = { readOnly: true };
const positionEditorOptions = { items: service.getPositions(), searchEnabled: true, value: '' };
const hireDateEditorOptions = { width: '100%', value: null };
const birthDateEditorOptions = { width: '100%', disabled: false };
const notesEditorOptions = { height: 90, maxLength: 200 };
const mobileEditorOptions = { readOnly: true };
//, mask: '+233 (X00) 000-0000', maskRules: { X: /[02-9]/ }
const Profile = () => {

  //const clientStore = GlobalParams.clientStore;
  //console.log(clientStore[0]);
  const [contactsData, setContactsData] = useState([]);
  const [clientStore, setClientStore] = useState({
    name: GlobalParams.clientStore[0].name,
    email: GlobalParams.clientStore[0].email,
    mobile: GlobalParams.clientStore[0].mobile,
    PhysicalAddress: GlobalParams.clientStore[0].PhysicalAddress,
    pin_no: GlobalParams.clientStore[0].pin_no,
  });

  useEffect(() => {
    fetchContacts();
    if(!GlobalParams.IsClientLoggedIn) {
      fetchBrokerDetails();
    }
  }, []);

  const fetchBrokerDetails = async () => {
    try {
      let url = GlobalParams.ApiUrlPrefix + "broker-info?broker_id=" + GlobalParams.IntermediaryId;
      //use axios to fetch data get
      const response = await axios.get(
        url,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken // Include bearer token in the Authorization header
          }
        }
      );
      setClientStore(response.data.data);
    } catch (error) {
      console.log(error);
      //notify(error.response.data.message, 'error', 5000);
    }
  }

  const fetchContacts = async () => {
    try {
      let url = GlobalParams.ApiUrlPrefix + "getGCContactPersons?gc_id=" + GlobalParams.ClientId;
      //http://localhost:8000/api/v1-gc-portal/broker-contact-persons?broker_id=
      if(!GlobalParams.IsClientLoggedIn) {
        url = GlobalParams.ApiUrlPrefix + 'broker-contact-persons?broker_id=' + GlobalParams.IntermediaryId;
      }
      //use axios to fetch data get
      const response = await axios.get(
        url,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken // Include bearer token in the Authorization header
          }
        }
      );
      setContactsData(response.data.data);
    } catch (error) {
      console.log(error);
      //notify(error.response.data.message, 'error', 5000);
    }
  }

  const validateForm = useCallback((e) => {
    e.component.validate();
  }, []);

  return (
    <div>
      <Form
        onContentReady={validateForm}
        formData={clientStore}
      >
        <GroupItem
          colCount={2}
          caption="Client Details"
        >
          <Item
            dataField="name"
            editorOptions={nameEditorOptions}
          >
            <Label render={LabelTemplate('name')} />
          </Item>

          {/* <Item
            dataField="ContactPerson"
          //editorOptions={nameEditorOptions}
          >
            <Label render={LabelTemplate('Contact Person')} />
          </Item> */}

          {/* <Item
          dataField="ContactPersEmail"
          //editorOptions={emailEditorOptions}
          validationRules={validationRules.email}
        >
          <Label text='Contact Person Email' />
        </Item> */}

          <Item
            dataField="email"
            editorOptions={emailEditorOptions}
            // validationRules={validationRules.email}
          >
            <Label render={LabelTemplate('email')} />
          </Item>

          <Item
            dataField="mobile"
            editorOptions={mobileEditorOptions}
            // validationRules={validationRules.mobile}
          >
            <Label render={LabelTemplate('Contanc No')} />
          </Item>
          <Item
            dataField="PhysicalAddress"
            editorOptions={physicalAddressEditorOptions}
            // validationRules={validationRules.address}
          >
            <Label render={LabelTemplate('Address')} />
          </Item>
          <Item
            dataField="pin_no"
            editorOptions={pin_noEditorOptions}
            // validationRules={validationRules.pin_no}
          >
            <Label render={LabelTemplate('TIN Number')} />
          </Item>
        </GroupItem>
      </Form>

    {/*TODO: add grid for contact persons*/}
    <br></br>
    <div style={{ color: '#2E86C1', fontWeight: 'bold' }}>Contact Persons</div>
      <DataGrid
        dataSource={contactsData}
        wordWrapEnabled={true}
        searchPanel={
          {
            visible: false,
            width: 250
          }
        }
      >
        <Column dataField="Contact" caption='Name'></Column>
        <Column dataField="ContactTelephone" caption='Telephone'></Column>
        <Column dataField="contact_position" caption='Position' visible={false}></Column>
        <Column dataField="ContactEmail" caption='Email'></Column>
      </DataGrid>
    </div>
  );
};
export default Profile;

const colCountByScreen = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4
};
